<style lang="scss" scoped>
.faceWrapper {
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  width: 1200px;
  height: 700px;
  margin: 20px auto;
  // border: 1px solid black;
  // dart-sass dont support /deep/ syntax
  ::v-deep video {
    width: 260px;
    height: 260px;
    object-fit: cover;
    // height: 90%;
  }
  .topWrapper{
    position: relative;
  }
  .goBackBtn{
    position: absolute;
    right: 63px;
    top: -9px;
  }
  .content {
    width: 1070px;
    height: 360px;
    margin: 0 auto;
    border: 1px dashed #7bbcff;
    background-color: #ebf6ff;
    display: grid;
    grid-template-columns: 313px 260px 1fr;
    .certPhotoWrapper {
      padding-top: 54px;
      box-sizing: border-box;
      .photoInnerWrapper {
        margin: 0 auto;
        width: 260px;
        height: 260px;
        border: 1px solid #e5e5e5;
        background-color: #e5e5e5;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }
      p {
        color: #3198ff;
      }
      img {
        width: 260px;
        height: 260px;
        // border: 1px solid #e5e5e5;
      }
    }
    .videoWrapper {
      padding-top: 54px;
      box-sizing: border-box;
      p {
        color: #3198ff;
      }
    }
    .videoInnerWrapper {
      width: 260px;
      height: 260px;
      background-color: #e5e5e5;
      position: relative;
      img {
        position: absolute;
        left: 25px;
        top: 20px;
      }
    }
    #videoBox {
      overflow: hidden;
    }
}
.textInfo {
  padding: 54px;
  text-align: left;
  p{
    margin: 0;
    line-height: 30px;
  }
}
}

/* 录制模式的样式 */
.contentUpload{
    width: 1070px;
    height: 360px;
    margin: 0 auto;
    border: 1px dashed #7bbcff;
    background-color: #ebf6ff;
    display: grid;
    grid-template-columns: 360px 1fr;
    .videoWrapper {
      padding-top: 54px;
      padding-left: 50px;
      box-sizing: border-box;
      p {
        color: #3198ff;
      }
    }
    .videoInnerWrapper {
      width: 260px;
      height: 260px;
      background-color: #e5e5e5;
      position: relative;
      img {
        position: absolute;
        left: 25px;
        top: 20px;
      }
    }
    #videoBox {
      overflow: hidden;
    }
}

.startCheck.el-button {
  border: none;
  border-radius: 20px;
  height: 40px;
  width: 200px;
  background-color: #3198ff;
  color: white;
}
.checkBtnWrapper,.startCheckWrapper {
  padding-top: 20px;
}
.reCheck.el-button {
  border: none;
  border-radius: 20px;
  height: 40px;
  width: 200px;
  background-color: #ff5400;
  color: white;
}
.goNext {
  border: none;
  width: 100px;
  height: 40px;
  background-color: #ffc831;
  color: #b16614;
  border-radius: 20px;
}
#downloadBox{
  text-align: left;
  ::v-deep video{
    width: 200px;
    height: 200px;;
    object-fit: contain;
  }
}
::v-deep .el-message-box {
  ::v-deep .el-message-box__message {
  ::v-deep p {
    font-size: 16px!important;
  }
}
}

</style>
<template>
  <div class="faceWrapper">
    <div class="topWrapper">
      <h2>{{uploadMode ? '实时视频录制' : '人脸验证'}}</h2>
      <el-button class="goBackBtn" @click="goBack">返回</el-button>
    </div>
    <div class="content" v-if="!uploadMode">
      <div class="certPhotoWrapper">
        <div class="photoInnerWrapper" :style="{backgroundImage: 'url(' + currentUser.photo + ')'}">
          <!-- <img :src="currentUser.photo" alt /> -->
        </div>
        <p>您的证件照</p>
      </div>
      <div class="videoWrapper">
        <div class="videoInnerWrapper">
          <img src="../../assets/images/videooutline.png" alt />
          <div id="videoBox"></div>
        </div>
        <p>您的视频画面</p>
      </div>
      <div class="textInfo">
        <p>操作提示：</p>
        <p>1.请先确保摄像头设备已连接并能正常工作；</p>
        <p>2.请保证光源充足，不要逆光操作；</p>
        <p>3.请保证脸部正常面向摄像头，并适当调整姿势保证整个脸能够进入右侧识别区域；</p>
        <p>4.系统识别通过后，将自动跳转进入考试界面；</p>
      </div>
    </div>
    <div class="contentUpload" v-else>
      <div class="videoWrapper">
        <div class="videoInnerWrapper">
          <img src="../../assets/images/videooutline.png" alt />
          <div id="videoBox"></div>
        </div>
        <p>您的视频画面</p>
      </div>
        <div class="textInfo">
        <p>操作提示：</p>
        <p>1.请面对摄像头录制3秒视频；</p>
        <p>2.请先确保摄像头设备已连接并能正常工作；</p>
        <p>3.请保证光源充足，不要逆光操作；</p>
        <p>4.请保证脸部正常面向摄像头，并适当调整姿势保证整个脸能够进入视频区域；</p>
      </div>
    </div>
    <div class="checkBtnWrapper" v-loading="faceCheckStatus === 2" v-if="!uploadMode && faceCheckGetter">
      <!-- 失败了，考前（超过次数，） -->
      <el-button
        :disabled="countDown>0 || isChecking || !faceCheckGetter || !recorderReady"
        v-show="(faceCheckStatus === -1 ||faceCheckStatus === 2)&&shouldShowStart"
        @click="startCheck"
        class="startCheck"
      >开始校验</el-button>
      <el-button
        :disabled="countDown>0 || JSON.stringify(myExam) === '{}' || !recorderReady"
        v-show="(faceCheckStatus === 0)&&shouldShowStart"
        @click="startCheck"
        class="reCheck"
      >重新校验</el-button>
      <el-button v-if="(faceCheckStatus === 1 || shouldShowFinish)" @click="goNext" class="goNext">完成</el-button>
      <el-button v-else-if="outOfTimes"  @click="useSwitchMode">确定</el-button>
      <p>{{checkTip}}</p>
    </div>
    <div v-loading="faceCheckStatus === 2" v-else-if="faceCheckGetter" class="startCheckWrapper">
      <el-button :disabled="!recorderReady" v-show="faceCheckStatus !== 1 &&shouldShowStart"  class="startCheck" @click="startCheck">开始录制</el-button>
      <el-button v-if="(faceCheckStatus === 1 || shouldShowFinish )" @click="goNext" class="goNext">完成</el-button>
      <p>{{uploadTip}}</p>
    </div>
  </div>
</template>
<script>
import {
 mapMutations, mapState, mapGetters, mapActions,
} from 'vuex';
import Deliver from '../../mixins/eventDeliver';
import uploadCdn from '../../mixins/uploadCdn';
import { postLiveRecog, getMyExam, postExaminationVideo } from '@/services/getData';
import {
  EXAMINEE, MYEXAM,
} from '@/store/types';
import Media from '../../utils/Media';

export default {
  data() {
    return {
      countDown: 0,
      poller: null,
      faceCheckDone: false, // 本次进来是否做过验证
      faceCheck: {},
      isChecking: false,
      faceCheckStatus: -1, // 0 失败，1成功了，2 进行中
      uploadMode: this.$route.query.upload, // 根据这个参数判断是upload模式还是自动模式
      recorderReady: false,
      faceMedia: null,
    };
  },
  mounted() {
    const options = {
      video: {
        frameRate: 15,
        width: 400,
        height: 480, // 我们这个摄像头高度最高超过不了480
      },
      audio: true,
      previewBox: 'videoBox',
      streamSource: 'camera',
      // downloadBox: 'downloadBox',
    };
    this.faceMedia = new Media(options);
    this.faceMedia.start().then((stream) => {
      this.faceMedia.initRecorder();
    });
    this.faceMedia.on('recorder-init-done', () => {
      this.recorderReady = true;
    });
    this.faceMedia.on('record-done', (dFile) => {
      if (this.uploadMode) {
      this.uploadWhenReady(dFile);
      } else {
        this.handleFileReady(dFile);
      }
    });
  },
  mixins: [Deliver, uploadCdn],
  methods: {
    ...mapMutations({
      setMyExam: MYEXAM,
      setExaminee: EXAMINEE,
    }),
    ...mapActions({
      disMyExam: MYEXAM,
    }),
    handleFileReady(file) {
      const size = `${parseFloat(file.size / 1024)}Kb`;
      // console.log(file, size);
      const reader = new FileReader();
      reader.readAsDataURL(file); // encode to base64 url with [data:*/*;base64] before the real base64 code
      reader.onload = () => {
        const pure64 = reader.result.split(',')[1]; // 去掉前缀
        const type = this.startInOneHour ? 1 : 2; //1 考试中，2考前测试
        postLiveRecog(this.examinee.examination_examinee_id, {
          video: pure64,
          type,
        })
          .then((resp) => {
            console.log(resp.data.token); // "9048de81-14cb-4566-8f14-246372f795b5"
            this.faceCheckDone = true;
            this.updateFaceCheck(true, type); // 设置成功的
            this.isChecking = false;
            this.faceCheckStatus = 1;
          })
          .catch((err) => {
            // console.log(err,'325325325325');
            this.isChecking = false;
            this.faceCheckDone = true;
            this.faceCheckStatus = 0;
            // this.checkFailed = true;
            if (typeof err.data.type && typeof err.data.errors.type[0] === 'string') {
              // console.log(err,'332332332332');
              // 理论上422才会返回字符串
              this.updateFaceCheck(false, type); // 设置失败的
              if (err.data.message.indexOf('[Exceed]') > -1) {
                this.$alert('您已使用完5次自助验证机会，将转入人工核验。我们将存取您正脸的实时视频，待考试结束之后进行人工核验。若核验结果非本人，您将会被视为作弊处理，请严格遵守考试规则',
                 '温馨提示', {
                  confirmButtonText: '确定',
                  callback: (action) => {
                    // this.$router.push('/user/myface?upload=1'); //TODO:这样不会销毁原来的组件，有点问题
                    location.href = '/user/myface?upload=1';
                  },
                });
              }
            }
          });
      };
      reader.onerror = (error) => {
        console.log('error', error);
      };
    },
    start() {
      this.faceCheckStatus = 2;
      if (this.countDown > 0) return;
      if (this.poller) {
        clearInterval(this.poller);
        this.poller = null;
      }
      this.faceMedia.startRecord();
      this.countDown = 3;
      this.poller = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown = this.countDown - 1;
        } else if (this.poller) {
          this.faceMedia.stopRecord();
          clearInterval(this.poller);
          this.poller = null;
        }
      }, 1000);
    },
    stop() {
      this.faceMedia.stopRecord();
    },
    startCheck() {
      console.log('开始校验');
      this.start();
    },
    goNext() {
      // TODO:
      const adminTicket = this.authority && this.authority.admissionTicket;

      this.disMyExam(adminTicket).then((resp) => {
        console.log(resp);
        if (!this.myExam.testing_status) {
           this.$router.push('/user/devicetest/1');
        } else if (this.canEnterExam) {
            this.$router.push('/exam');
        } else {
          this.$router.push('/user/myExam');
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    updateFaceCheck(passed, type) {
      const now = new Date();
      const faceCheck = JSON.parse(
        localStorage.getItem(`faceCheck-${this.authority.admissionTicket}`),
      );
      if (type !== 3) {
        if (type === 2) faceCheck.count += 1; // 只记录考前测试的次数
        if (type === 1) faceCheck.ancount += 1; // 记录的是考试中的次数
        faceCheck.timestamp = now;
        if (passed) faceCheck.successStamp = now;
      } else {
        faceCheck.uploadStamp = now;
      }
        this.faceCheck = faceCheck;

      localStorage.setItem(
          `faceCheck-${this.authority.admissionTicket}`,
          JSON.stringify(faceCheck),
        );
    },
    getMyExam() {
      const adminTicket = this.authority && this.authority.admissionTicket;
      return getMyExam(adminTicket)
        .then((resp) => {
          this.setMyExam(resp);
          this.setExaminee({
            examination_examinee_id: resp.id,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    useSwitchMode() {
      location.href = '/user/myface?upload=1';
    },
    uploadWhenReady(file) {
      const type = this.startInOneHour ? 1 : 0; // 考前传0，考中传1
      this.mixinUploadToCdn(file)
        .then((url) => {
          // console.log(url);
          postExaminationVideo(this.examinee.examination_examinee_id, {
            type,
            video_url: url,
          }).then((result) => {
            console.log('should do something here after upload to cdn');
            this.disMyExam(this.authority.admissionTicket).then(() => {
              this.updateFaceCheck(true, 3); // 只更新uploadedStamp
              this.faceCheckStatus = 1;
            }).catch((err) => {
              console.log(err);
            });
          }).catch((err) => {
            this.faceCheckStatus = 0;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.disMyExam(this.authority.admissionTicket);
      this.$router.push('/user/myexam');
    },
  },
  components: {},
  created() {
    const faceCheck = localStorage.getItem(
      `faceCheck-${this.authority.admissionTicket}`,
    );
    let obj;
    if (!faceCheck) {
      obj = {
        timestamp: null,
        count: 0,
        ancount: 0,
        successStamp: null,
        uploadStamp: null, // 是否有录制过视频上传
      }; // count 考前次数，ancount 考试中的次数
      this.faceCheck = obj;
      localStorage.setItem(
        `faceCheck-${this.authority.admissionTicket}`,
        JSON.stringify(obj),
      );
    } else {
      this.faceCheck = JSON.parse(faceCheck);
    }
  },
  props: {},
  watch: {},

  computed: {
    ...mapState({
      authority: 'authority',
      examinee: 'examinee',
      currentUser: 'currentUser',
      myExam: 'myExam',
      serverTime: 'serverTime',
    }),
    ...mapGetters({
      faceCheckGetter: 'faceCheckGetter',
    }),
    outOfTimes() {
      if (this.faceCheckGetter) {
        return (this.faceCheckGetter.count >= 5 && this.startInOneHour) || (this.faceCheckGetter.precount >= 5 && !this.startInOneHour);
      }
      return true;
    },
    checkTip() {
      if (this.myExam.is_test_check || (this.myExam.match_category === 3 || this.myExam.match_category === 2 || this.myExam.is_online === 1)) {
        return '您无需进行人脸验证';
      }
      if ((this.checkedInOneHour || this.uploadedInOneHour) && this.faceCheckStatus === -1) {
        return '您已经在考前1小时内验证通过，无需重复验证。';
      }
      if (this.outOfTimes) {
        return '您已进行过五次人脸检测，请使用人工验证功能。';
      }
      if (this.countDown > 0) {
        return `视频采集中，还剩${this.countDown}秒。`;
      }
      if (this.myExam.examinee_tencent_face_testing && !this.startInOneHour && this.faceCheckStatus === -1) {
        return '您已通过考前人脸验证。';
      }
      switch (this.faceCheckStatus) {
        case -1:
          return '点击按钮开始验证。';
        case 0:
          return '验证失败，请更换背景或者调整人脸角度，进行重新验证！';
        case 1:
          return '恭喜您成功完成人脸验证，点击进行跳转。';
        case 2:
          return '校验中，请稍候...';
        default:
        // no default
      }
      return '';
    },

    canEnterExam() {
      // 是否在考试时间内
      if (
        new Date(this.serverTime) > new Date(this.myExam.end_at)
        || new Date(this.serverTime) < new Date(this.myExam.start_at)
      ) {
        return false;
      }
      if (
        new Date(this.myExam.start_at) - new Date(this.faceCheck.successStamp)
        > 60 * 60 * 1000 && new Date(this.myExam.start_at) - new Date(this.faceCheck.uploadStamp)
        > 60 * 60 * 1000 && !this.myExam.is_test_check && this.myExam.match_category !== 3
      ) { return false; } // 考前1小时内没检测过,或者没有上传过视频
      return true;
    },
    checkedInOneHour() {
    const value =        this.faceCheck.successStamp
        && new Date(this.myExam.start_at) - new Date(this.faceCheck.successStamp)
          < 60 * 60 * 1000;
          console.log(value);
          return value;
    },
    uploadedInOneHour() {
     const value = this.faceCheck.uploadStamp && new Date(this.myExam.start_at) - new Date(this.faceCheck.uploadStamp) < 60 * 60 * 1000;
     console.log(value);
     return value;
    },
    startInOneHour() { // 考前1小时加上考中
      return (new Date(this.myExam.start_at) - new Date(this.serverTime) <= 60 * 60 * 1000)  && (new Date(this.serverTime) < new Date(this.myExam.end_at));
    },
    uploadTip() {
      if (this.myExam.is_test_check || this.myExam.match_category === 3 || this.myExam.match_category === 2 || this.myExam.is_online === 1) {
        return '您无需进行人脸验证';
      }
      if (this.countDown > 0) {
        return `视频采集中，还剩${this.countDown}秒。`;
      }
      if ((this.checkedInOneHour || this.uploadedInOneHour) && this.faceCheckStatus === -1) {
        return '您已经在考前1小时内验证通过，无需重复验证。';
      }
      if (this.myExam.examinee_tencent_face_testing && !this.startInOneHour && this.faceCheckStatus === -1) {
        return '您已通过考前人脸验证。';
      }
      switch (this.faceCheckStatus) {
        case -1:
          return '点击按钮开始验证。';
        case 0:
          return '验证失败，请更换背景或者调整人脸角度，进行重新验证！';
        case 1:
          return '恭喜您成功上传了人脸验证视频，点击进入进行跳转。';
        case 2:
          return '校验中，请稍候...';
        default:
        // no default
      }
      return '';
    },
    shouldShowStart() { // 应该展示开始校验按钮
      const fcg = this.faceCheckGetter;
      if (this.myExam && (this.myExam.is_test_check)) return false;
      if (this.faceCheckGetter) {
        if (!this.uploadMode) {
          if (this.startInOneHour) { // 按考中算
            return fcg.count < 5 && !this.checkedInOneHour; // 超过5次就不显示了
          } // 考前
            return fcg.precount < 5 && !this.faceCheckGetter.prepassed;
        }
          return !this.uploadedInOneHour;
      }
      return false;
    },
    shouldShowFinish() {
      return this.checkedInOneHour || this.uploadedInOneHour || (this.myExam.examinee_tencent_face_testing && !this.startInOneHour) || this.myExam.is_test_check ||
      this.myExam.match_category === 3 || this.myExam.match_category === 2 || this.myExam.is_online === 1;
    },

  },
};
</script>
